import { isFiniteNumber } from './numbers';
import type { Nil } from './type-utils';

export type CorridorBounds = {
    innerMin: number;
    innerMax: number;
};

export type ParameterStatus = 'green' | 'yellow' | 'red' | 'white';

type CalculateStatusArgs = {
    corridorParameterMargins: CorridorBounds;
    value: number | Nil;
};

export const calculateStatus = ({ corridorParameterMargins, value }: CalculateStatusArgs): ParameterStatus => {
    const min = Math.min(corridorParameterMargins.innerMin, corridorParameterMargins.innerMax);
    const max = Math.max(corridorParameterMargins.innerMin, corridorParameterMargins.innerMax);
    const range = max - min;
    const outerMax = max + range * 0.1;
    const outerMin = min - range * 0.1;
    if ((min === 0 && max === 0) || !isFiniteNumber(value)) {
        return 'white';
    }

    if (value >= min && value <= max) return 'green';
    if ((value >= outerMin && value <= min) || (value <= outerMax && value >= max)) return 'yellow';
    if (value > outerMax || value < outerMin) return 'red';
    return 'white';
};
